import { api } from "../../../services/apiClient";
import type {
  DownloadUrlResponse,
  FileListItem,
  RenameFileRequest,
  ReplaceInitResponse,
  UploadBatchFileInput,
  UploadBatchResponse,
  UploadCompleteRequest,
  UploadCompleteResponse,
} from "../types/project-storage.types";
import { projectStorageBasePath } from "./paths";

/** E07 — POST /projects/:mmCode/files/upload/batch */
export async function uploadBatch(
  mmCode: number,
  folderId: string,
  files: UploadBatchFileInput[]
): Promise<UploadBatchResponse> {
  const { data } = await api.post<UploadBatchResponse>(
    `${projectStorageBasePath(mmCode)}/files/upload/batch`,
    { folderId, files }
  );
  return data;
}

/** E08 — POST /projects/:mmCode/files/upload/complete */
export async function uploadComplete(
  mmCode: number,
  body: UploadCompleteRequest
): Promise<UploadCompleteResponse> {
  const { data } = await api.post<UploadCompleteResponse>(
    `${projectStorageBasePath(mmCode)}/files/upload/complete`,
    body
  );
  return data;
}

/** E09 — POST /projects/:mmCode/files/:fileId/replace */
export async function replaceFile(
  mmCode: number,
  fileId: string,
  body: UploadBatchFileInput
): Promise<ReplaceInitResponse> {
  const { data } = await api.post<ReplaceInitResponse>(
    `${projectStorageBasePath(mmCode)}/files/${fileId}/replace`,
    body
  );
  return data;
}

/** E10 — GET /projects/:mmCode/files/:fileId/download-url */
export async function getDownloadUrl(
  mmCode: number,
  fileId: string
): Promise<DownloadUrlResponse> {
  const { data } = await api.get<DownloadUrlResponse>(
    `${projectStorageBasePath(mmCode)}/files/${fileId}/download-url`
  );
  return data;
}

/** E11 — PATCH /projects/:mmCode/files/:fileId */
export async function renameFile(
  mmCode: number,
  fileId: string,
  body: RenameFileRequest
): Promise<FileListItem> {
  const { data } = await api.patch<FileListItem>(
    `${projectStorageBasePath(mmCode)}/files/${fileId}`,
    body
  );
  return data;
}

/** E12 — DELETE /projects/:mmCode/files/:fileId (204 empty body) */
export async function deleteFile(mmCode: number, fileId: string): Promise<void> {
  await api.delete(`${projectStorageBasePath(mmCode)}/files/${fileId}`);
}
